(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_banner-parent"] && !Shopify.designMode) return;
  try {
    function initBannerGrid() {
    const bannerParents = document.querySelectorAll('.banner-parent');
    bannerParents.forEach(function (bannerParent) {
      const bannerItems = bannerParent.querySelectorAll('.banner-item');
      bannerParent.classList.add('grid-' + bannerItems.length);
    });
  }

  initBannerGrid();  
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', initBannerGrid);
    document.addEventListener('shopify:section:deselect', initBannerGrid);
    document.addEventListener('shopify:section:reorder', initBannerGrid);
    document.addEventListener('shopify:block:select', initBannerGrid);
    document.addEventListener('shopify:block:deselect', initBannerGrid);
    document.addEventListener('shopify:section:load', initBannerGrid);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-complementary-products"] && !Shopify.designMode) return;
  try {
    function lrCompBundleFormatMoney(cents) {
    return (Number(cents || 0) / 100).toFixed(2) + 'TL';
  }

  function lrCompBundleRefresh(wrapper) {
    if (!wrapper) return;

    var checkedItems = Array.prototype.slice.call(wrapper.querySelectorAll('.lr-comp-bundle__checkbox:checked:not(:disabled)'));
    var savingTarget = wrapper.querySelector('[data-lr-comp-bundle-saving]');
    var countTarget = wrapper.querySelector('[data-lr-comp-bundle-count]');
    var button = wrapper.querySelector('[data-lr-comp-bundle-add]');
    var totalSaving = checkedItems.reduce(function(sum, input) {
      return sum + Number(input.getAttribute('data-saving') || 0);
    }, 0);

    if (savingTarget) savingTarget.textContent = lrCompBundleFormatMoney(totalSaving);
    if (countTarget) countTarget.textContent = String(checkedItems.length);
    if (button) {
      var totalProducts = checkedItems.length + 1;
      button.textContent = totalProducts > 1
        ? 'Seçili ' + totalProducts + ' Ürünü Sepete Ekle'
        : 'Ana Ürünü Sepete Ekle';
    }
  }

  document.addEventListener('change', function(event) {
    if (!event.target.matches) return;
    if (!event.target.matches('.lr-comp-bundle__checkbox')) return;

    var wrapper = event.target.closest('[data-lr-comp-bundle]');
    if (!wrapper) return;

    lrCompBundleRefresh(wrapper);
  });

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-lr-comp-bundle-add]');
    if (!button) return;

    var wrapper = button.closest('[data-lr-comp-bundle]');
    if (!wrapper) return;

    var selectedItems = [];
    var mainVariantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]:not([disabled])');
    var mainVariantId = mainVariantInput ? mainVariantInput.value : wrapper.getAttribute('data-main-variant-id');

    if (mainVariantId) {
      selectedItems.push({
        id: Number(mainVariantId),
        quantity: 1
      });
    }

    wrapper.querySelectorAll('.lr-comp-bundle__checkbox:checked:not(:disabled)').forEach(function(input) {
      selectedItems.push({
        id: Number(input.getAttribute('data-variant-id')),
        quantity: 1
      });
    });

    if (!selectedItems.length) return;

    button.disabled = true;
    button.textContent = 'Ekleniyor...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: selectedItems
      })
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function() {
        window.location.href = '/cart';
      })
      .catch(function() {
        button.disabled = false;
        lrCompBundleRefresh(wrapper);
      });
  });

  document.querySelectorAll('[data-lr-comp-bundle]').forEach(lrCompBundleRefresh);

  if (window.MutationObserver) {
    var lrCompBundleObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (!node.querySelectorAll) return;

          if (node.matches && node.matches('[data-lr-comp-bundle]')) {
            lrCompBundleRefresh(node);
          }

          node.querySelectorAll('[data-lr-comp-bundle]').forEach(lrCompBundleRefresh);
        });
      });
    });

    lrCompBundleObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide-parent"] && !Shopify.designMode) return;
  try {
    function addAnimateDelayToSlides() {
    const swiperWrappers = document.querySelectorAll('.swiper-wrapper_parent');
    swiperWrappers.forEach(function(swiperWrapper) {
      const slideItems = swiperWrapper.querySelectorAll('.swiper-slide_item');
      slideItems.forEach(function(slideItem, index) {
        if (index > 0) {
          const contentSlides = slideItem.querySelectorAll('.content-slide');
          contentSlides.forEach(function(contentSlide) {
            contentSlide.classList.add('animate-delay');
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', addAnimateDelayToSlides);
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:reorder', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:load', addAnimateDelayToSlides);
  }
  } catch(e) { console.error(e); }
})();

})();
